module.exports = __webpack_public_path__ + "static/media/The curve.70280625.jpeg";